module.exports = __webpack_public_path__ + "img/bottom_back.40c5274e.png";